import { NavLink } from "react-router-dom";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "~/components/ui";
import { routes } from "~/lib/constants";
import { findRecordWithFullAccess } from "~/lib/utils";
import { useSelector } from "~/redux/store";

const ViewAction = () => {
  const permissions = useSelector(
    (state) => state.persistedReducer.auth.permissions,
  );

  const accessibleMenuItems = MenuItems.filter((menu) =>
    findRecordWithFullAccess(permissions, menu.id),
  );

  if (accessibleMenuItems.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="secondary"
          size="default"
          className="flex h-9 items-center gap-2"
        >
          <Icon name="Eye" className="h-4 w-4 text-primary-500" />
          <span>View</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {accessibleMenuItems
          ?.filter((menu) => findRecordWithFullAccess(permissions, menu?.id))
          .map((item, index) => (
            <NavLink to={item?.link} className="" key={index}>
              <DropdownMenuItem key={index} className="group cursor-pointer">
                {item?.name}
              </DropdownMenuItem>
            </NavLink>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
const MenuItems = [
  {
    id: "view_incidents",
    name: "Incident",
    link: routes.incidents(),
  },
  {
    id: "view_observations",
    name: "Observation",
    link: routes.observations(),
  },
  {
    id: "view_eligibility_permits",
    name: "Eligibility Permit",
    link: routes.eligibilityPermits(),
  },
  {
    id: "view_competence_permits",
    name: "Competence Permit",
    link: routes.competencePermits(),
  },
  {
    id: "view_company_wide_permits",
    name: "Company-Wide Permit",
    link: routes.companyWidePermits(),
  },
  {
    id: "view_site_specific_permits",
    name: "Site-Specific Permit",
    link: routes.siteSpecificPermits(),
  },
  {
    id: "view_inspections",
    name: "Inpections",
    link: routes.inspections(),
  },
  {
    id: "view_audits",
    name: "Audit",
    link: routes.audits(),
  },
];

export default ViewAction;
